module.exports = __webpack_public_path__ + "static/media/Museum_of_the_new_South_Charlotte_NC_Faux_painted_marble_finished_paint_1.92d7c170.webp";